/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit {
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit
     */
    restriction?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit
     */
    detail?: number;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit {
    return JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'restriction': !exists(json, 'restriction') ? undefined : json['restriction'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'restriction': value.restriction,
        'detail': value.detail,
    };
}

